import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const activateFreePlan = payload => {
  let token = localStorage.getItem("token");
  payload.plan = "free";
  return axios.post(`${API_URL}/api/v1/activate-free-plan/`, payload, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

const buyBusinessPlan = payload => {
  let token = localStorage.getItem("token");
  payload.plan = "business";
  return axios.post(`${API_URL}/api/v1/buy-business-plan/`, payload, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

const buyGrowthPlan = payload => {
  let token = localStorage.getItem("token");
  payload.plan = "growth";
  return axios.post(`${API_URL}/api/v1/buy-growth-plan/`, payload, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

const buyEnterprisePlan = payload => {
  let token = localStorage.getItem("token");
  payload.plan = "enterprise";
  return axios.post(`${API_URL}/api/v1/buy-enterprise-plan/`, payload, {
    headers: {
      Authorization: `JWT ${token}`
    }
  });
};

export { activateFreePlan, buyBusinessPlan, buyGrowthPlan, buyEnterprisePlan };
